export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";